/* ============================================================
   crest-overlays.js - cart drawer, predictive search, quick view.

   Isolated from crest.js (which drives the verified home page) so a fault here
   cannot take that down. Every entry point is guarded; if the markup is absent
   the whole file no-ops.

   NOT implemented, deliberately: viewer counts and countdown timers.
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function lock(on) { document.body.classList.toggle('crest-no-scroll', !!on); }
  function money(cents) {
    try {
      var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
        { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------------- cart drawer ---------------- */
  function drawer() { return $('#cart-drawer-main'); }

  function openCart() {
    var d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    var ov = $('[data-cart-overlay]'); if (ov) ov.classList.add('is-open');
    lock(true);
    d.focus();
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    var ov = $('[data-cart-overlay]'); if (ov) ov.classList.remove('is-open');
    lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshCart() {
    return fetch(root + '?section_id=crest-cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-cart-body]', '[data-cart-foot]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var live = $(sel);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () { /* leave the drawer as-is on failure */ });
  }

  function initCart() {
    if (!drawer()) return;

    // Header cart button and floating cart open the drawer instead of navigating.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.site-header__icon-btn--cart, .stickycart, [data-cart-open]');
      if (trigger) { e.preventDefault(); openCart(); return; }

      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
      if (e.target.closest('[data-cart-overlay]')) { closeCart(); return; }

      var rm = e.target.closest('[data-cart-remove]');
      if (rm) {
        e.preventDefault();
        fetch(rm.getAttribute('href'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function () { return refreshCart(); })
          .then(function () { document.dispatchEvent(new CustomEvent('crest:cart:count')); })
          .catch(function () {});
      }
    });

    // crest.js fires this after a quick add.
    document.addEventListener('crest:cart:changed', function () {
      refreshCart().then(openCart);
    });
  }

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    var drop = $('#search-drop');
    if (!drop) return;
    var input = $('[data-search-input]', drop);
    var results = $('[data-search-results]', drop);
    var popular = $('[data-search-popular]', drop);
    var overlay = $('[data-search-overlay]');
    var timer = null;

    function open() {
      lastFocus = document.activeElement;
      drop.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      lock(true);
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      drop.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.site-header__icon-btn--search-mobile, [data-search-open]')) {
        e.preventDefault(); open(); return;
      }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-search-overlay]')) { close(); }
    });

    // Focusing the desktop header field promotes to the overlay.
    var headerInput = $('.site-header__search input');
    if (headerInput) {
      headerInput.addEventListener('focus', function (e) {
        e.preventDefault();
        headerInput.blur();
        open();
      });
    }

    function render(products, term) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = '<div class="search-drop__empty">No matches for “' + term + '”.</div>';
        return;
      }
      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        return '<a class="search-drop__hit" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" width="52" height="52">' : '<span></span>') +
          '<span class="search-drop__hit-title">' + p.title + '</span>' +
          '<span class="search-drop__hit-price">' + (p.price != null ? money(p.price) : '') + '</span>' +
          '</a>';
      }).join('');
      html += '<a class="search-drop__all" href="' + root + 'search?q=' + encodeURIComponent(term) +
              '&type=product">See all results for “' + term + '”</a>';
      results.innerHTML = html;
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        if (timer) clearTimeout(timer);
        if (popular) popular.style.display = term ? 'none' : '';
        if (term.length < 2) { if (results) results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
                    '&resources[type]=product&resources[limit]=6';
          fetch(url)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data && data.resources && data.resources.results &&
                              data.resources.results.products) || [];
              render(products, term);
            })
            .catch(function () { if (results) results.innerHTML = ''; });
        }, 220);
      });
    }
  }

  /* ---------------- quick view ---------------- */
  function initQuickView() {
    var modal = $('#pqv');
    if (!modal) return;
    var inner = $('[data-pqv-inner]', modal);
    var overlay = $('[data-pqv-overlay]');

    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      lock(true);
      modal.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pqv-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-pqv-overlay]')) { close(); return; }

      var trigger = e.target.closest('[data-crest-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.getAttribute('data-crest-quick-view');
      if (!handle) return;

      if (inner) inner.innerHTML = '<div class="pqv__loading">Loading</div>';
      open();

      fetch(root + 'products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (!inner) return;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var desc = (p.description || '').replace(/<script[\s\S]*?<\/script>/gi, '');
          var vid = p.variants && p.variants.length ? p.variants[0].id : '';
          var avail = p.available;
          inner.innerHTML =
            '<div class="pqv__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
            '<div>' +
              '<h2 class="pqv__title">' + p.title + '</h2>' +
              '<div class="pqv__price">' + money(p.price) + '</div>' +
              '<div class="pqv__desc">' + desc + '</div>' +
              (avail
                ? '<button class="btn btn--titanium btn--block" data-crest-quick-add="' + vid + '">Add to cart</button>'
                : '<button class="btn btn--outline btn--block" disabled>Sold out</button>') +
              '<a class="search-drop__all" href="' + p.url + '">View full details</a>' +
            '</div>';
        })
        .catch(function () {
          if (inner) inner.innerHTML = '<div class="pqv__loading">Could not load this product</div>';
        });
    });
  }

  /* ---------------- shared ---------------- */
  function initEscape() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var pqv = $('#pqv');
      var drop = $('#search-drop');
      var d = drawer();
      if (pqv && pqv.classList.contains('is-open')) { pqv.classList.remove('is-open'); }
      else if (drop && drop.classList.contains('is-open')) { drop.classList.remove('is-open'); }
      else if (d && d.classList.contains('is-open')) { d.classList.remove('is-open'); }
      else return;
      document.querySelectorAll('.cart-overlay, .search-drop__overlay, .pqv-overlay')
        .forEach(function (o) { o.classList.remove('is-open'); });
      lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
  }

  ready(function () {
    initCart();
    initSearch();
    initQuickView();
    initEscape();
  });
})();
